import { render, staticRenderFns } from "./OnboardingWizard.vue?vue&type=template&id=5126ffaa&scoped=true"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js"
import style0 from "./OnboardingWizard.vue?vue&type=style&index=0&id=5126ffaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126ffaa",
  null
  
)

export default component.exports